"use client";
import Image from "next/image";
import { signOut } from "next-auth/react";
const handleLogout = async () => {
  await signOut({ callbackUrl: "/login" });
  // router.push("/login");
};

const Component = () => {
  return (
    <div className="flex  flex-row shadow-2xl justify-between w-full items-center px-5">
      <div className="w-full max-w-[10%] xl:max-w-[7vw] py-5 ">
        <Image
          src={"/assets/logo.webp"}
          className="w-full h-auto object-cover"
          width={1200}
          height={1200}
          alt="hero logo"
        />
      </div>
      <div></div>

      <div className="flex flex-col">
        <button
          onClick={handleLogout}
          className="border border-red-400 p-5  flex flex-row items-center justify-center space-x-2 text-red-400 rounded-lg cursor-pointer hover:bg-red-400 hover:text-white group "
        >
          <svg
            className="w-6 h-6 text-red-400 group-hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M16 12H4m12 0-4 4m4-4-4-4m3-4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2"
            />
          </svg>
          <span className="">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Component;
